import axios from "axios";
import { API_URL } from "constants/base";

const login = (identifier, password) => {
  return axios
    .post(API_URL + "/auth/local", {
      identifier,
      password,
    })
    .then((response) => {
      if (response.data.jwt) {
        window.sessionStorage.setItem("jwt", response.data.jwt);
        window.sessionStorage.setItem(
          "user",
          JSON.stringify(response.data.user)
        );
      }

      return response.data;
    });
};

const logout = async () => {
  await window.sessionStorage.removeItem("jwt");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

export { login, logout, getCurrentUser };
